import { FaSpinner } from 'react-icons/fa';

export const RHFSubmitButton = ({
  label = 'Submit',
  isSubmitting,
}: {
  label?: string;
  isSubmitting: boolean;
}) => {
  return (
    <button
      type='submit'
      className='my-2 w-full max-w-68.75 rounded-md border border-slate-950 bg-transparent p-2 text-xs font-bold uppercase hover:border-gray-400 hover:text-gray-400 dark:border-gray-500 dark:hover:border-gray-300 dark:hover:text-gray-300'
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        <div className='flex items-center justify-center'>
          <FaSpinner className='animate-spin ' />
        </div>
      ) : (
        label
      )}
    </button>
  );
};
